module.exports = __webpack_public_path__ + "media/jpg/get-job-offers-pick-1-mob@3x-d5217deb.jpg";